import { PatientHeaderBandSkeleton } from '@/components/patients/PatientHeaderBand/PatientHeaderBandSkeleton';
import { Box, Skeleton } from '@mui/material';

import { PatientDetailsFrame } from './PatientDetailsFrame';
import { calendarRailColumnSx } from './railLayout';

// Route-level fallback that renders without reading anything, so it ships light with the routes.
export const PatientDetailsFrameSkeleton = () => (
    <PatientDetailsFrame
        header={<PatientHeaderBandSkeleton />}
        rightRail={
            <Box sx={calendarRailColumnSx}>
                <Skeleton variant='rectangular' height='100%' />
            </Box>
        }
    >
        {null}
    </PatientDetailsFrame>
);
